export const GET_TEMPLATES = {
    'missed': {
        'name': 'Missed consultation template',
        'case_category': [
            { 'value': 'Gen. Medicine' }, { 'value': 'Pediatric', 'sub': 'General Pediatrics' }
        ],
        'diagnosis': {
            'code': 'Z53.2',
            'description': 'Procedure and treatment not carried',
            'impression': 'Unattended by patient' 
        },
        'recommendation': {
            'point_of_care': 'Telecare',
            'time_to_treat': 'Telecare',
            'action': 'Unattended by patient, no document sent'
        },
        'notes': {
            'title': 'Missed consult',
            'note': 'Call time: {{Remove bracket and enter data in the field}} \nPatient\'s number/s dialed: {{Remove bracket and enter data in the field}} \nReason for missed consult: {{Remove bracket and enter data in the field}}'
        },
        'documents': [],
        'option': {
            'value': 'missed',
            'label': 'Missed Consult',
            'sub_label': 'Unattended call, Busy number, Cannot be reached'
        }
    },
    'cancelled': {
        'name': 'Cancelled consultation template',
        'case_category': [
            { 'value': 'Gen. Medicine' }, { 'value': 'Pediatric', 'sub': 'General Pediatrics' }
        ],
        'diagnosis': {
            'code': 'Z53.2',
            'description': 'Procedure and treatment not carried',
            'impression': 'Cancelled Consult' 
        },
        'recommendation': {
            'point_of_care': 'Telecare',
            'time_to_treat': 'Telecare',
            'action': 'Cancelled consult, no document sent'
        },
        'notes': {
            'title': 'Cancelled consult',
            'note': 'Reason for cancellation: {{Remove bracket and enter data in the field}}'
        },
        'documents': [],
        'option': {
            'value': 'cancelled',
            'label': 'Cancelled Consult',
            'sub_label': 'Consultations cancelled by the patient'
        }
    },
    'rescheduled': {
        'name': 'Rescheduled consultation template',
        'case_category': [
            { 'value': 'Gen. Medicine' }, { 'value': 'Pediatric', 'sub': 'General Pediatrics' }
        ],
        'diagnosis': {
            'code': 'Z53.2',
            'description': 'Procedure and treatment not carried',
            'impression': 'Rescheduled Consult' 
        },
        'recommendation': {
            'point_of_care': 'Telecare',
            'time_to_treat': 'Telecare',
            'action': 'Rescheduled consult per patient\'s request, no document sent'
        },
        'notes': {
            'title': 'Rescheduled consult',
            'note': 'Reason for rescheduling: {{Remove bracket and enter data in the field}} \nPreferred Time: {{Remove bracket and enter data in the field}}'
        },
        'documents': [],
        'option': {
            'value': 'rescheduled',
            'label': 'Rescheduled Consult',
            'sub_label': 'Consultations rescheduled by the patient'
        }
    },
    'telephony': {
        'name': 'Telephony error template',
        'case_category': [
            { 'value': 'Gen. Medicine' }, { 'value': 'Pediatric', 'sub': 'General Pediatrics' }
        ],
        'diagnosis': {
            'code': 'Z53.2',
            'description': 'Procedure and treatment not carried',
            'impression': 'Teleconsult not carried out' 
        },
        'recommendation': {
            'point_of_care': 'Telecare',
            'time_to_treat': 'Telecare',
            'action': 'Teleconsult not carried out, no document sent'
        },
        'notes': {
            'title': 'Telephony Error',
            'note': 'Call time: {{Remove bracket and enter data in the field}} \nPatient\'s number/s dialed: {{Remove bracket and enter data in the field}} \nError prompt: {{Remove bracket and enter data in the field}}'
        },
        'documents': [],
        'option': {
            'value': 'telephony',
            'label': 'Telephony Error',
            'sub_label': 'No or insufficient load, contact administrator, called number does not exist, number cannot be completed as dialed, call forbidden'
        }
    },
}